<template>
  <div class="box" :style="isShareSession ? 'padding-top:75px;padding-left:10px':'' ">
    <div id="edit-form" class="px-4">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-xl-12 mx-auto">
          <div
            class="alert alert-warning"
            v-show="
              $session.get('role') === 0 &&
              showWarningFlag &&
              threshold(pageview.monthly / trackedCount()) &&
              showWarning()
            "
          >
            <span class="close cursor-pointer" @click="hideWarning()"
              >&times;</span
            >
            <b>🚨 Heads up!</b> You have exceeded your account's monthly page
            views limits, you may want to consider upgrade your account to
            prevent restricted usage.
            <br />
            <router-link
              tag="a"
              to="/subscription"
              class="a-link text-muted font-weight-bold"
            >
              <span>Upgrade account</span>
            </router-link>
            <br />
          </div>
          <div
            class="alert alert-primary"
            v-show="Number($session.get('user_id')) === 2572"
          >
            This is only a demo account, you can sign up for a full access
            15-day free trial! 👉
            <a
              href="https://app.howuku.com/sign-up/basic"
              class="a-link text-muted font-weight-bold"
            >
              <span class="text-first">Get Started Now</span>
            </a>
            <br />
          </div>
        </div>

        <div class="col-sm-12 col-md-12 col-xl-12 mx-auto">
          <div
            id="accordion2"
            v-if="1 === 2 && isLoaded && getCompletedCount() !== 0"
          >
            <div
              v-if="funnelVal || feedbackVal || recordVal"
              class="card card-accordion"
            >
              <div
                class="card-header no-drag"
                @click="bigTitleNo = bigTitleNo !== 2 ? 2 : 0"
              >
                <div class="row">
                  <div
                    style="display: table; width: 25px; white-space: nowrap"
                    class="my-auto text-right mx-3"
                  >
                    <font-awesome-icon
                      :icon="
                        bigTitleNo === 2 ? 'chevron-down' : 'chevron-right'
                      "
                    />
                  </div>
                  <div class="col-md-8">
                    <h5 class="mb-1" v-translate>Enable Popular Use Cases</h5>
                    <span class="text-muted" v-translate
                      >Get more out of this tool</span
                    >
                  </div>
                  <div class="col-3 ml-auto my-auto">
                    <div
                      class="text-muted float-right text-right py-auto"
                    ></div>
                  </div>
                </div>
              </div>
              <div v-if="bigTitleNo === 2">
                <div class="pt-2 card-body-custom">
                  <div v-if="funnelVal" class="card card-accordion">
                    <div
                      class="card-header sub-header no-drag"
                      @click="showCardNo = showCardNo !== 1 ? 1 : 0"
                    >
                      <span class="mb-0">
                        <font-awesome-icon
                          class="fa-sm mr-4 ml-3"
                          :icon="
                            showCardNo === 1 ? 'chevron-down' : 'chevron-right'
                          "
                        />{{ t('Analyze your conversion rates') }}
                      </span>
                    </div>
                    <div v-if="showCardNo === 1">
                      <div class="card-body">
                        <p>
                          {{
                            t(
                              'Funnel to illustrates the journey of your visitors go through on their way to becoming customers.'
                            )
                          }}
                          <br />
                          <br />
                          <router-link
                            tag="button"
                            class="btn btn-first"
                            to="/funnel"
                          >
                            <span>{{ t('Add a funnel') }}</span>
                          </router-link>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-if="feedbackVal" class="card card-accordion">
                    <div
                      class="card-header sub-header no-drag"
                      @click="showCardNo = showCardNo !== 2 ? 2 : 0"
                    >
                      <span class="mb-0">
                        <font-awesome-icon
                          class="fa-sm mr-4 ml-3"
                          :icon="
                            showCardNo === 2 ? 'chevron-down' : 'chevron-right'
                          "
                        />{{ t('Customize your feedback widget') }}
                      </span>
                    </div>
                    <div v-if="showCardNo === 2">
                      <div class="card-body">
                        <p>
                          {{
                            t(
                              'Change up the look and feel to suit your website theme color and styles.'
                            )
                          }}
                          <br />
                          <br />
                          <router-link
                            tag="button"
                            class="btn btn-first"
                            to="/feedback"
                          >
                            <span>{{ t('Change style') }}</span>
                          </router-link>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-if="feedbackVal" class="card card-accordion">
                    <div
                      class="card-header sub-header no-drag"
                      @click="showCardNo = showCardNo !== 3 ? 3 : 0"
                    >
                      <span class="mb-0">
                        <font-awesome-icon
                          class="fa-sm mr-4 ml-3"
                          :icon="
                            showCardNo === 3 ? 'chevron-down' : 'chevron-right'
                          "
                        />{{ t('Create poll and start asking question') }}
                      </span>
                    </div>
                    <div v-if="showCardNo === 3">
                      <div class="card-body">
                        <p>
                          {{
                            t(
                              'Get to know about what your users demand from your product. Ask a question.'
                            )
                          }}
                          <br />
                          <br />
                          <router-link
                            tag="button"
                            class="btn btn-first"
                            to="/feedback"
                          >
                            <span>{{ t('Create poll') }}</span>
                          </router-link>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-if="recordVal" class="card card-accordion">
                    <div
                      class="card-header sub-header no-drag"
                      @click="showCardNo = showCardNo !== 4 ? 4 : 0"
                    >
                      <span class="mb-0">
                        <font-awesome-icon
                          class="fa-sm mr-4 ml-3"
                          :icon="
                            showCardNo === 4 ? 'chevron-down' : 'chevron-right'
                          "
                        />{{ t('Start recording your users activity') }}
                      </span>
                    </div>
                    <div v-if="showCardNo === 4">
                      <div class="card-body">
                        <p>
                          {{
                            t(
                              "Record and replay every movement, click and scroll of a visitor's session."
                            )
                          }}
                          <br />
                          <br />
                          <button
                            class="btn btn-first"
                            @click="
                              showEdit($session.get('widget_id'), 'record')
                            "
                          >
                            <span>{{ t('Start recording') }}</span>
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- <div class="row">
            <div class="col-md-12">
              LIVE USERS
            </div>
            <div class="col-md-12" v-for="(item, key) in liveRecordingData" :key="key">
              {{ item.session }} <a target="_blank" :href="'http://localhost:8080/live-recording/' + item.session">View Recording</a>
            </div>
          </div> -->

          <div>
            <div class="row" style="justify-content:space-between">
              <div class="col-md-6 pb-2 text-left my-auto">
                <div class="ml-2">
                  <h4 class="font-weight-bolder" v-if="!isShareSession">
                    Hello
                    {{
                      $session.get('name')
                        ? $session.get('name').split(' ')[0]
                        : ''
                    }}<br />
                  </h4>
                  <h4 class="font-weight-bolder" v-else>
                    Hello Stranger<br />
                  </h4>
                  <!-- <span class="text-muted fs-16">Welcome back!</span> -->
                  <!-- <div class="text-left my-auto pt-2">
                    <AirbnbDatePicker
                      class="cursor-pointer d-inline-block align-top"
                      module="dashboard"
                    ></AirbnbDatePicker>
                  </div> -->
                </div>

                <!-- <span class="text-muted2 p-3">
                  <template v-if="currentOnline !== 0">
                    <div class="m-0 ml-1 d-inline-block rec-dot mr-2 Rec"></div>
                  </template>
                  <template v-else>
                    <div
                      class="m-0 ml-1 d-inline-block rec-dot mr-2 notRec"
                    ></div>
                  </template>
                  {{ currentOnline }} visitors online
                </span> -->
              </div>
              <div>
                <button v-if="!isShareSession && isAdminRole && $isHowuku" class="btn btn-muted mr-3" @click="openShareLinkSettings() ">
                        <font-awesome-icon v-if="!isPublicShare" icon="lock" class="mr-1"></font-awesome-icon>  
                        <font-awesome-icon v-else icon="link" class="mr-1"></font-awesome-icon>  
                        <span>Share Link</span>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="row mt-2 mb-4" style="margin-left: -1rem; margin-right: -1rem">
                  <!-- <div class="col-sm-12 col-md-3 px-0 mx-0">
                    <div class="listing mx-3 text-center">
                      <p
                        class="
                          text-muted2
                          font-weight-bold
                          mb-2
                          text-uppercase
                          fs-12
                        "
                        style="letter-spacing: 0.5px"
                      >
                        {{ t('Visitors Online') }}
                      </p>
                      <div v-if="statsLoaded">
                        <span
                          class="h2 font-weight-bolder"
                          :rel="thousandFormat(currentOnline)"
                          >{{ shortNumber(currentOnline) }}</span
                        >
                      </div>
                      <div
                        v-else
                        class="placeholder placeholder-heading w-25 mb-1"
                      ></div>
                    </div>
                  </div> -->
                  <div class="col-xs-6 col-lg-6 col-xl-3 px-0 mx-0 mt-2">
                    <div class="listing mx-3 text-center">
                      <p
                        class="
                          text-muted2
                          font-weight-bold
                          mb-2
                          text-uppercase
                          fs-12
                        "
                        style="letter-spacing: 0.5px"
                      >
                        {{ t('Total sessions') }}
                        <span
                          class="tooltip-pop cursor-pointer"
                          rel="A session is the browsing period of a user."
                        >
                          <font-awesome-icon
                            icon="info-circle"
                            class="fa-sm text-muted"
                          />
                        </span>
                      </p>
                      <div v-if="statsLoaded">
                        <span
                          class="h2 font-weight-bolder"
                          :rel="thousandFormat(pageview.unique)"
                          >{{ shortNumber(pageview.unique) }}</span
                        >
                        <!-- <TrendChart
                          :datasets="[
                            {
                              data: pageview.count_history,
                              smooth: true,
                              fill: true,
                            },
                          ]"
                          :min="0"
                        ></TrendChart> -->
                      </div>
                      <div
                        v-else
                        class="placeholder placeholder-heading w-25 mb-1"
                      ></div>
                    </div>
                  </div>
                  <div class="col-xs-6 col-lg-6 col-xl-3 px-0 mx-0 mt-2">
                    <div class="listing mx-3 text-center">
                      <p
                        class="
                          text-muted2
                          font-weight-bold
                          mb-2
                          text-uppercase
                          fs-12
                        "
                        style="letter-spacing: 0.5px"
                      >
                        {{ t('Pages per session') }}
                        <span
                          class="tooltip-pop cursor-pointer"
                          rel="Pages per session is the average number of pages a person views in a given session."
                        >
                          <font-awesome-icon
                            icon="info-circle"
                            class="fa-sm text-muted"
                          />
                        </span>
                      </p>
                      <div v-if="statsLoaded">
                        <!-- v-bind:class="{
                            'text-normal': 1 === 1,
                            'text-success':
                              Number(pageview.count / pageview.unique) > 4,
                            'text-warning':
                              Number(pageview.count / pageview.unique) <= 1.7,
                          }"                         -->
                        <span
                          class="h2 font-weight-bolder"
                          :rel="
                            Number(pageview.count / pageview.unique) > 5
                              ? 'Excellent! This put you in the best 10%'
                              : Number(pageview.count / pageview.unique) > 4
                              ? 'Excellent! This put you in the best 20%'
                              : Number(pageview.count / pageview.unique) > 3
                              ? 'You are doing good'
                              : Number(pageview.count / pageview.unique) <= 1.7
                              ? 'Not ideal. Below average.'
                              : 'You are doing fine'
                          "
                          >{{
                            pageview.unique
                              ? shortNumber(
                                  Number(
                                    pageview.count / pageview.unique
                                  ).toFixed(1)
                                )
                              : 0
                          }}</span
                        >
                        <!-- <TrendChart
                          :datasets="[
                            {
                              data: pageview.count_history,
                              smooth: true,
                              fill: true,
                            },
                          ]"
                          :min="0"
                        ></TrendChart> -->
                      </div>
                      <div
                        v-else
                        class="placeholder placeholder-heading w-25 mb-1"
                      ></div>
                    </div>
                  </div>
                  <div class="col-xs-6 col-lg-6 col-xl-3 px-0 mx-0 mt-2">
                    <div class="listing mx-3 text-center">
                      <p
                        class="
                          text-muted2
                          font-weight-bold
                          mb-2
                          text-uppercase
                          fs-12
                        "
                        style="letter-spacing: 0.5px"
                      >
                        {{ t('Average session duration') }}
                        <span
                          class="tooltip-pop cursor-pointer"
                          rel="Average session duration measures the average length of sessions on your website."
                        >
                          <font-awesome-icon
                            icon="info-circle"
                            class="fa-sm text-muted"
                          />
                        </span>
                      </p>

                      <div v-if="statsLoaded">
                        <!-- v-bind:class="{
                            'text-normal': 1 === 1,
                            'text-success': pageview.rawSessionTime >= 120,
                            'text-warning': pageview.rawSessionTime < 25,
                          }"                         -->
                        <span
                          class="h2 font-weight-bolder"
                          :rel="
                            pageview.rawSessionTime > 120
                              ? 'You are doing very well'
                              : pageview.rawSessionTime < 25
                              ? 'It is not ideal'
                              : 'You are doing fine'
                          "
                          >{{ sessionTime }}</span
                        >
                      </div>
                      <div
                        v-else
                        class="placeholder placeholder-heading w-25 mb-1"
                      ></div>
                    </div>
                  </div>
                  <div class="col-xs-6 col-lg-6 col-xl-3 px-0 mx-0 mt-2">
                    <div class="listing mx-3 text-center">
                      <p
                        class="
                          text-muted2
                          font-weight-bold
                          mb-2
                          text-uppercase
                          fs-12
                        "
                        style="letter-spacing: 0.5px"
                      >
                        {{ t('Average Bounce Rate') }}
                        <span
                          class="tooltip-pop cursor-pointer"
                          rel="Bounce Rate is a way of measuring the number of people who left your website after viewing only one page."
                        >
                          <font-awesome-icon
                            icon="info-circle"
                            class="fa-sm text-muted"
                          />
                        </span>
                      </p>

                      <div v-if="statsLoaded">
                        <!-- v-bind:class="{
                            'text-normal': 1 === 1,
                            'text-success': bounce >= 20 && bounce <= 40,
                            'text-warning':
                              (bounce >= 65.01 && bounce <= 70) || bounce <= 10,
                            'text-danger': bounce >= 70.01,
                          }" -->
                        <span
                          class="h2 font-weight-bolder"
                          :rel="
                            bounce >= 20 && bounce <= 40
                              ? 'Your bounce rate is excellent!'
                              : bounce >= 40.01 && bounce <= 65
                              ? 'Your bounce rate is good'
                              : bounce >= 65.01 && bounce <= 70
                              ? 'Bounce rate is a little high'
                              : bounce >= 70.01
                              ? 'Bounce rate is too high'
                              : 'Bounce rate is extraordinarily low'
                          "
                          >{{ bounce }}%</span
                        ><br />
                        <span class="small"></span>
                      </div>
                      <div
                        v-else
                        class="placeholder placeholder-heading w-25 mb-1"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-xs-12 mb-4 col-lg-12 col-xl-6">
                    <div class="listing px-0 pt-0 pb-0" style="max-height: 360px; min-height: 360px">
                      <h6 style="padding: 24px" class="font-weight-bold align-middle mb-0" :key="reportKey">
                        {{ t('Top pages') }}
                        <ul class="float-right ul_top_hypers pl-3 ml-1 my-auto">
                          <li
                            class="custom-badge cursor-pointer custom-sizing mr-2"
                            @click="topPageShow = 'visit'"
                            v-bind:class="{
                              'badge-third': topPageShow === 'visit',
                            }"
                          >
                            Visits
                          </li>
                          <li
                            class="custom-badge cursor-pointer custom-sizing mr-2"
                            @click="topPageShow = 'ref'"
                            v-bind:class="{
                              'badge-third': topPageShow === 'ref',
                            }"
                          >
                            Referrer
                          </li>
                        </ul>
                        <br />
                        <p class="pt-2 fs-12 text-muted font-weight-light mb-0"
                          >The top pages your users visited.</p
                        >
                      </h6>

                      <div v-if="topPageShow === 'visit'">
                        <template
                          v-if="
                            pagesLoaded && (!topPages || topPages.length === 0)
                          "
                        >
                          <div
                            class="text-center p-4 mx-auto"
                            style="width: 60%"
                          >
                            <img
                              width="80"
                              class="d-block mx-auto mb-2"
                              src="../assets/img/no-record.png"
                            />
                            <p class="font-weight-bold">No results found</p>
                            <p class="text-muted">
                              No data available for the selected period
                            </p>
                            <!-- <p class="text-muted">
                              Some users can’t be tracked. Learn more
                            </p> -->
                          </div>
                        </template>
                        <template v-else>
                          <div class="table-responsive">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th>URL</th>
                                  <th class="text-right">Pageviews</th>
                                </tr>
                              </thead>
                              <tbody>
                                <template v-if="pagesLoaded">
                                  <template v-for="(item, key) in topPages">
                                    <tr>
                                      <td class="w-60 p-1 my-auto">
                                        <div class="bg-highlight p-2" :style="`width:${(item / topPages[Object.keys(topPages)[0]]) * 100}%`">
                                          <span class="pointer a-link" @click="(!isShareSession) ? openDetail(key, 'filter-url') : ''">{{ shorten(removeDomain(key), 40) }}</span> <a :href="'https://' + key" target="_blank"><div class="d-inline text-muted mr-1" style="border-radius: 50%;"><font-awesome-icon class="fa fa-sm" icon="external-link-alt" /></div></a>
                                        </div>
                                      </td>

                                      <td class="text-right font-weight-bold small text-muted2 my-auto align-middle" style="white-space: nowrap;">
                                        {{ shortNumber(item) }}
                                        <!-- <div :rel="t('Filter Pages')" @click="(!isShareSession) ? openDetail(key, 'filter-url') : ''" class="ml-2 text-muted ml-3 tooltip-pop d-inline-block" style="border-radius:50%; border: none!important; "><font-awesome-icon class="fa fa-sm cursor-pointer" icon="filter" /></div> -->
                                        <div :rel="t('View Heatmap')" @click="(!isShareSession) ?openDetail(key, 'heatmap'): ''" class="ml-2 text-muted ml-3 tooltip-pop d-inline-block" style="border-radius:50%; border: none!important; "><font-awesome-icon class="fa fa-sm cursor-pointer" icon="fire" /></div>
                                        <div :rel="t('View Recording')" @click="(!isShareSession) ? openDetail(key, 'recording'): ''" class="ml-2 text-muted ml-3 tooltip-pop d-inline-block" style="border-radius:50%; border: none!important; "><font-awesome-icon class="fa fa-sm cursor-pointer" icon="play" /></div>
                                      </td>
                                    </tr>                               
                                  </template>
                                </template>
                                <template v-else>
                                  <tr v-for="index in 4" :key="index">
                                    <td class="w-60">
                                      <div class="placeholder placeholder-sentence mb-1" :style="`width:${Number(100 / index)}%`"></div>
                                    </td>
                                    <td class="text-right font-weight-bold small text-muted2 my-auto align-middle" style="white-space: nowrap;">
                                      <div class="placeholder placeholder-sentence w-25 mb-1 float-right"></div>
                                    </td>
                                  </tr>
                                </template>
                              </tbody>
                            </table>
                          </div>
                        </template>
                      </div>
                      <div v-else-if="topPageShow === 'ref'">
                        <template
                          v-if="
                            channelLoaded &&
                            (!topChannels || topChannels.length === 0)
                          "
                        >
                          <div
                            class="text-center p-4 mx-auto"
                            style="width: 60%"
                          >
                            <img
                              width="80"
                              class="d-block mx-auto mb-2"
                              src="../assets/img/no-record.png"
                            />
                            <p class="font-weight-bold">No results found</p>
                            <p class="text-muted">
                              No data available for the selected period
                            </p>
                            <!-- <p class="text-muted">
                              Some users can’t be tracked. Learn more
                            </p> -->
                          </div>
                        </template>
                        <template v-else>
                          <div class="table-responsive">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th>URL</th>
                                  <th class="text-right">Pageviews</th>
                                </tr>
                              </thead>
                              <tbody>
                                <template v-if="channelLoaded">
                                  <tr v-for="(item, key) in topChannels" v-bind:key="key">
                                    <td class="w-60 p-1">
                                      <div class="bg-highlight p-2" :style="`width:${(item / topChannels[Object.keys(topChannels)[0]]) * 100}%`">
                                        <span class="pointer a-link" @click="(!isShareSession) ? openDetail(key, 'filter-referrer') : ''">{{ shorten(key, 40) }}</span> <a :href="'https://' + key" target="_blank"><div class="d-inline text-muted mr-1" style="border-radius: 50%;"><font-awesome-icon class="fa fa-sm" icon="external-link-alt" /></div></a>
                                      </div>
                                    </td>
                                    <td class="text-right font-weight-bold small text-muted2 my-auto align-middle" style="white-space: nowrap;">
                                      {{ shortNumber(item) }}
                                      <!-- <div :rel="t('View Heatmap')" @click="openDetail(key, 'heatmap')" class="ml-2 text-muted ml-3 tooltip-pop d-inline-block" style="border-radius:50%; border: none!important; "><font-awesome-icon class="fa fa-sm cursor-pointer" icon="fire" /></div> -->
                                      <!-- <div :rel="t('Filter Pages')" @click="openDetail(key, 'filter-referrer')" class="ml-2 text-muted ml-3 tooltip-pop d-inline-block" style="border-radius:50%; border: none!important; "><font-awesome-icon class="fa fa-sm cursor-pointer" icon="filter" /></div> -->
                                      <div :rel="t('View Recording')" @click="openDetail(key, 'referrer')" class="ml-2 text-muted ml-3 tooltip-pop d-inline-block" style="border-radius:50%; border: none!important; "><font-awesome-icon class="fa fa-sm cursor-pointer" icon="play" /></div>
                                    </td>
                                  </tr>
                                </template>
                                <template v-else>
                                  <tr v-for="index in 4" :key="index">
                                    <td class="w-60">
                                      <div class="placeholder placeholder-sentence mb-1" :style="`width:${Number(100 / index)}%`"></div>
                                    </td>
                                    <td class="text-right font-weight-bold small text-muted2 my-auto align-middle" style="white-space: nowrap;">
                                      <div class="placeholder placeholder-sentence w-25 mb-1 float-right"></div>
                                    </td>
                                  </tr>
                                </template>
                              </tbody>
                            </table>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 mb-4 col-lg-12 col-xl-6">
                    <div
                      class="listing px-0 pt-0 pb-0"
                      style="max-height: 360px; min-height: 360px"
                    >
                      <h6 style="padding: 24px" class="font-weight-bold align-middle mb-0" :key="reportKey">
                        {{ t('Top clicked buttons & links') }}
                        <ul class="float-right ul_top_hypers pl-3 ml-1 my-auto">
                          <li
                            class="custom-badge cursor-pointer custom-sizing mr-2"
                            @click="
                              topEventShow = 'all'
                              loadEvents('all')
                            "
                            v-bind:class="{
                              'badge-third': topEventShow === 'all',
                            }"
                          >
                            All
                          </li>
                          <li
                            class="custom-badge cursor-pointer custom-sizing mr-2"
                            @click="
                              topEventShow = 'click'
                              loadEvents('click')
                            "
                            v-bind:class="{
                              'badge-third': topEventShow === 'click',
                            }"
                          >
                            Clicked
                          </li>
                          <li
                            class="custom-badge cursor-pointer custom-sizing mr-2"
                            @click="
                              topEventShow = 'event'
                              loadEvents('event')
                            "
                            v-bind:class="{
                              'badge-third': topEventShow === 'event',
                            }"
                          >
                            Events
                          </li>
                        </ul>
                        <br />
                        <p class="pt-2 fs-12 text-muted font-weight-light mb-0"
                          >The top events your users clicked/triggered.</p
                        >
                      </h6>
                      <div>
                        <template
                          v-if="
                            eventLoaded &&
                            (!topEvents || topEvents.length === 0)
                          "
                        >
                          <div
                            class="text-center p-4 mx-auto"
                            style="width: 60%"
                          >
                            <img
                              width="80"
                              class="d-block mx-auto mb-2"
                              src="../assets/img/no-record.png"
                            />
                            <p class="font-weight-bold">No results found</p>
                            <p class="text-muted">
                              No data available for the selected period
                            </p>
                            <p
                              class="text-muted"
                              v-if="topEventShow !== 'click' && $isHowuku"
                            >
                              <a
                                class="a-link text-muted"
                                href="https://howuku.freshdesk.com/support/solutions/articles/150000072548-how-to-track-custom-event-with-api-"
                                target="_blank"
                                >Learn more</a
                              >
                              about how you can track specific events with
                              Javascript.
                            </p>
                            <p
                              class="text-muted"
                              v-if="topEventShow === 'click'"
                            >
                              All clicks event will show up in here.
                            </p>
                          </div>
                        </template>
                        <template v-else>
                          <div class="table-responsive">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th>Event</th>
                                  <th class="text-right">Clicks</th>
                                </tr>
                              </thead>
                              <tbody>
                                <template v-if="eventLoaded">
                                  <tr v-for="(item, key) in topEvents" v-bind:key="key">
                                    <td class="w-60 p-1">
                                      <div class="bg-highlight p-2" :style="'width:' + (item / topEvents[Object.keys(topEvents)[0]]) * 100 + '%'"
                                      >
                                        <span :rel="t('View Details')" class="tooltip-pop pointer a-link" @click="(!isShareSession) ? openDetail(key.replace(/@@@.*/g, '') , key.endsWith('1') ? 'click' : 'event') : ''">{{ key.replace(/@@@.*/g, '') }}</span>
                                      </div>
                                    </td>
                                    <td class="text-right font-weight-bold small text-muted2 my-auto align-middle" style="white-space: nowrap;">
                                      {{ shortNumber(item) }}
                                      <!-- <div :rel="t('View Details')" @click="(!isShareSession) ? openDetail(key.replace(/@@@.*/g, '') , key.endsWith('1') ? 'click' : 'event') : ''" class="ml-2 text-muted ml-3 tooltip-pop d-inline-block" style="border-radius:50%; border: none!important; "><font-awesome-icon class="fa fa-sm cursor-pointer" icon="eye" /></div> -->
                                      <div :rel="t('View Recording')" @click="(!isShareSession) ?openDetail(key.replace(/@@@.*/g, ''), `recording-${key.endsWith('1') ? 'click' : 'event'}`):''" class="ml-2 text-muted ml-3 tooltip-pop d-inline-block" style="border-radius:50%; border: none!important; "><font-awesome-icon class="fa fa-sm cursor-pointer" icon="play" /></div>
                                    </td>
                                  </tr>
                                </template>
                                <template v-else>
                                  <tr v-for="index in 4" :key="index">
                                    <td class="w-60">
                                      <div class="placeholder placeholder-sentence mb-1" :style="`width:${Number(100 / index)}%`"></div>
                                    </td>
                                    <td class="text-right font-weight-bold small text-muted2 my-auto align-middle" style="white-space: nowrap;">
                                      <div class="placeholder placeholder-sentence w-25 mb-1 float-right"></div>
                                    </td>
                                  </tr>
                                </template>
                              </tbody>
                            </table>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 mb-4 col-lg-12 col-xl-6">
                    <div
                      class="listing px-0 pt-0 pb-0"
                      style="max-height: 360px; min-height: 360px"
                    >
                      <h6 style="padding: 24px" class="font-weight-bold align-middle mb-0" :key="reportKey">
                        {{ t('Technology') }}
                        <ul class="float-right ul_top_hypers pl-3 ml-1 my-auto">
                          <li
                            class="custom-badge cursor-pointer custom-sizing mr-2"
                            @click="
                              topTechShow = 'browser'
                              loadTechnologies('browser')
                            "
                            v-bind:class="{
                              'badge-third': topTechShow === 'browser',
                            }"
                          >
                            Browsers
                          </li>
                          <li
                            class="custom-badge cursor-pointer custom-sizing mr-2"
                            @click="
                              topTechShow = 'device'
                              loadTechnologies('device')
                            "
                            v-bind:class="{
                              'badge-third': topTechShow === 'device',
                            }"
                          >
                            Devices
                          </li>
                          <li
                            class="custom-badge cursor-pointer custom-sizing mr-2"
                            @click="
                              topTechShow = 'os'
                              loadTechnologies('os')
                            "
                            v-bind:class="{
                              'badge-third': topTechShow === 'os',
                            }"
                          >
                            Operating Systems
                          </li>
                        </ul>
                        <br />
                        <p class="pt-2 fs-12 text-muted font-weight-light mb-0"
                          >The devices your visitors had.</p
                        >
                      </h6>
                      <div>
                        <template
                          v-if="
                            technologyLoaded &&
                            (!topTech || topTech.length === 0)
                          "
                        >
                          <div
                            class="text-center p-4 mx-auto"
                            style="width: 60%"
                          >
                            <img
                              width="80"
                              class="d-block mx-auto mb-2"
                              src="../assets/img/no-record.png"
                            />
                            <p class="font-weight-bold">No results found</p>
                            <p class="text-muted">
                              No data available for the selected period
                            </p>
                            <!-- <p class="text-muted">
                              Some users can’t be tracked. Learn more
                            </p> -->
                          </div>
                        </template>
                        <template v-else>
                          <div class="table-responsive">
                            <table class="table">
                              <thead>
                                <tr>
                                  <th>Event</th>
                                  <th class="text-right">Clicks</th>
                                </tr>
                              </thead>
                              <tbody>
                                <template v-if="technologyLoaded">
                                  <tr v-for="(item, key) in topTech" v-bind:key="key">
                                    <td class="w-60 p-1">
                                      <div class="bg-highlight p-2" :style="'width:' + (item / topTech[Object.keys(topTech)[0]]) *100 +'%' " >
                                        {{ key }}
                                      </div>
                                    </td>
                                    <td class="text-right font-weight-bold small text-muted2 my-auto align-middle" style="white-space: nowrap;">
                                      {{ shortNumber(item) }}
                                      <!-- <div :rel="t('View Heatmap')" @click="openDetail(key, 'heatmap')" class="ml-2 text-muted ml-3 tooltip-pop d-inline-block" style="border-radius:50%; border: none!important; "><font-awesome-icon class="fa fa-sm cursor-pointer" icon="fire" /></div> -->
                                      <div :rel="t('View Recording')" @click="(!isShareSession) ? openDetail(key, 'recording-' + topTechShow) :''" class="ml-2 text-muted ml-3 tooltip-pop d-inline-block" style="border-radius:50%; border: none!important; "><font-awesome-icon class="fa fa-sm cursor-pointer" icon="play" /></div>
                                    </td>
                                  </tr>
                                </template>
                                <template v-else>
                                  <tr v-for="index in 4" :key="index">
                                    <td class="w-60">
                                      <div class="placeholder placeholder-sentence mb-1" :style="`width:${Number(100 / index)}%`"></div>
                                    </td>
                                    <td class="text-right font-weight-bold small text-muted2 my-auto align-middle" style="white-space: nowrap;">
                                      <div class="placeholder placeholder-sentence w-25 mb-1 float-right"></div>
                                    </td>
                                  </tr>
                                </template>
                              </tbody>
                            </table>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-lg-6 mb-4 col-xl-3">
                    <div
                      class="listing mx-1"
                      style="min-height: 360px !important"
                    >
                      <h6 class="font-weight-bold align-middle">
                        {{ t('New vs Returning') }}
                        <br />
                        <p class="pt-2 fs-12 text-muted font-weight-light mb-0"
                          >Compare sessions between first-time and users.</p>
                      </h6>
                      <template v-if="newVsReturn.new + newVsReturn.return">
                        <div class="text-center my-4">
                          <svg width="70%" viewBox="0 0 20 20">
                            <circle
                              r="10"
                              cx="10"
                              cy="10"
                              style="fill: rgba(var(--main-color), 1)"
                            />
                            <circle
                              r="5"
                              cx="10"
                              cy="10"
                              fill="transparent"
                              stroke="tomato"
                              stroke-width="10"
                              :stroke-dasharray="
                                'calc(' +
                                (newVsReturn.return /
                                  (newVsReturn.new + newVsReturn.return)) *
                                  100 +
                                ' * 31.4 / 100) 31.4'
                              "
                              transform="rotate(-90) translate(-20)"
                            />
                          </svg>
                        </div>
                        <span
                          class="float-left font-weight-bold"
                          style="color: rgba(var(--main-color), 1)"
                        >
                          <div
                            style="
                              background-color: rgba(var(--main-color), 1); 
                              width: 20px;
                              height: 20px;
                              display: inline;
                              margin-right: 10px;
                            "
                          >
                            █
                          </div>
                          <span class="small font-weight-bold"
                            >New
                            {{
                              (
                                (newVsReturn.new /
                                  (newVsReturn.new + newVsReturn.return)) *
                                100
                              ).toFixed(2)
                            }}%</span
                          >
                        </span>
                        <span
                          class="float-right font-weight-bold"
                          style="color: tomato"
                        >
                          <div
                            style="background-color: tomato; 
                              width: 20px;
                              height: 20px;
                              display: inline;
                              margin-right: 10px;
                            "
                          >
                            █
                          </div>
                          <span class="small font-weight-bold"
                            >Returning
                            {{
                              (
                                (newVsReturn.return /
                                  (newVsReturn.new + newVsReturn.return)) *
                                100
                              ).toFixed(2)
                            }}%</span
                          >
                        </span>
                      </template>
                      <template v-else>
                        <div
                          class="text-center p-4 mx-auto"
                          style="margin-top: 10px"
                        >
                          <img
                            width="80"
                            class="d-block mx-auto mb-2"
                            src="../assets/img/no-record.png"
                          />
                          <p class="font-weight-bold">No results found</p>
                          <p class="text-muted">
                            No data available for the selected period
                          </p>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="col-xs-12 col-lg-6 mb-4 col-xl-3">
                    <div
                      class="listing mx-1"
                      style="
                        max-height: 360px !important;   
                        min-height: 360px !important;
                      "
                    >
                      <h6 class="font-weight-bold align-middle">
                        <span @click="(!isShareSession) ? $router.push('/visitor/map'):expandMap()">
                          <div
                            class="tooltip-pop cursor-pointer d-inline mr-1"
                            rel="Expand to view more"
                          >
                            <font-awesome-icon
                              icon="expand"
                              class="text-muted fa-sm"
                            />
                          </div>
                        </span>
                        {{ t('Top countries') }}
                        <br />
                        <p class="pt-2 fs-12 text-muted font-weight-light mb-0"
                          >The top countries your users visited
                      </p>
                      </h6>
                      <MapChart
                        preserveAspectRatio="none"
                        :countryData="countryData"
                        :highColor="getThemeColor(1)"
                        :lowColor="getThemeColor(0.3)"
                        countryStrokeColor="#5f5f5f"
                        defaultCountryFillColor="transparent"
                      />
                    </div>
                  </div>
                  <!-- <div class="col-xs-12 mb-4 col-lg-12 col-xl-6">
                    <div class="listing mx-1 p-0">
                      <h6
                        class="font-weight-bold px-4 pb-2 d-inline-block pt-3"
                      >
                        {{ t('Acquisition channel') }}
                      </h6>
                      <span class="float-right my-1 mr-2">
                        <select
                          class="custom-select fs-14"
                          v-model="acquisition.selected"
                          @change="changeAcquisitionPeriod"
                        >
                          <option value="1">Last 24 hours</option>
                          <option value="2">Last 7 day</option>
                          <option value="3">Last 2 week</option>
                          <option value="4">Last 1 month</option>
                        </select>
                      </span>
                      <AcquisitionChannel
                        v-bind:key="cohort.key"
                        :interval="acquisition.interval"
                        :period="acquisition.period"
                      ></AcquisitionChannel>
                    </div>
                  </div> -->
                  <!-- <div class="col-xs-12 mb-4 col-lg-12 col-xl-6">
                    <div class="listing mx-1 p-0">
                      <h6
                        class="font-weight-bold px-4 pb-2 d-inline-block pt-3"
                      >
                        {{ t('Visitor retention') }}
                      </h6>

                      <span class="float-right my-1 mr-2">
                        <select
                          class="custom-select fs-14"
                          v-model="cohort.selected"
                          @change="changeCohortPeriod"
                        >
                          <option value="1">Last 7 days</option>
                          <option value="2">Last 3 week</option>
                          <option value="3">Last 6 week</option>
                          <option value="4">Last 3 months</option>
                        </select>
                      </span>

                      <CohortGraph
                        :key="cohort.key"
                        :interval="cohort.interval"
                        :period="cohort.period"
                      ></CohortGraph>
                    </div>
                  </div> -->
                </div>
              </div>
              <!-- <div class="col-xs-12 col-md-4 pr-0 mb-4">
                <div class="row">
                  <div class="col-md-12">
                    <div class="listing mx-1 p-0">
                      <h6
                        class="font-weight-bold align-middle" style="padding: 24px"
                       0> <router-link to="/visitor/realtime"><div
                            class="tooltip-pop cursor-pointer d-inline mr-1"
                            rel="Expand to view more"
                          >
                            <font-awesome-icon
                              icon="expand"
                              class="text-muted fa-sm"
                            />
                          </div>
                        </router-link>
                        {{ t('Real-time visitors') }}
                      </h6>
                      <Visitor :widgetId="$session.get('widget_id')"></Visitor>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- <modal
        style="z-index: 10000"
        name="widget-modal"
        :adaptive="true"
        width="100%"
        height="100%"
        @before-open="modalOnOpen"
        @before-close="modalOnClose"
      >
        <WidgetForm :editId="editId" :feature="selectedFeature"></WidgetForm>
      </modal> -->

      <modal
        style="z-index: 10000"
        name="announcement"
        :adaptive="true"
        width="900px"
        height="auto"
        styles="border-radius: 10px;"
      >
        <announcement :message="message"></announcement>
      </modal>

      <modal
        style="z-index: 10000; border-radius: 14px"
        name="choose-option"
        :adaptive="true"
        width="650px"
        height="auto"
      >
        <div class="p-4">
          <div class="row mb-2">
            <div class="col-md-10">
              <span class="font-weight-bold fs-20">Choose an action</span><br />
              <span class="text-muted">Get more insights out of it</span>
            </div>
          </div>
          <div class="row">
            <div
              class="py-4 choices-block"
              v-bind:class="{
                'col-md-4': option2show.length >= 3,
                'col-md-6': option2show.length < 3,
              }"
              v-if="option2show.includes('recording-url')"
              @click="openDetail(optionItem, 'recording')"
            >
              <p class="mx-1">
                <font-awesome-icon
                  class="fa-lg text-muted mb-2"
                  icon="video"
                /><br />
                <b>Watch recording</b><br />
                <span class="text-muted"
                  >See what everyone is doing in <b>{{ optionItem }}</b
                  >.</span
                >
              </p>
            </div>
            <div
              class="py-4 choices-block"
              v-bind:class="{
                'col-md-4': option2show.length >= 3,
                'col-md-6': option2show.length < 3,
              }"
              v-if="option2show.includes('recording-referrer')"
              @click="openDetail(optionItem, optionCriteria)"
            >
              <p class="mx-1">
                <font-awesome-icon
                  class="fa-lg text-muted mb-2"
                  icon="video"
                /><br />
                <b>Watch recording</b><br />
                <span class="text-muted"
                  >See what people are doing on your website that is coming from
                  <b>{{ optionItem }}</b
                  >.</span
                >
              </p>
            </div>
            <div
              class="py-4 choices-block"
              v-bind:class="{
                'col-md-4': option2show.length >= 3,
                'col-md-6': option2show.length < 3,
              }"
              v-if="option2show.includes('heatmap-url')"
              @click="openDetail(optionItem, 'heatmap')"
            >
              <p class="mx-1">
                <font-awesome-icon
                  class="fa-lg text-muted mb-2"
                  icon="fire"
                /><br />
                <b>Watch heatmap</b><br />
                <span class="text-muted"
                  >Find out all the hotspot in <b>{{ optionItem }}</b
                  >.</span
                >
              </p>
            </div>
            <div
              class="py-4 choices-block"
              v-bind:class="{
                'col-md-4': option2show.length >= 3,
                'col-md-6': option2show.length < 3,
              }"
              v-if="option2show.includes('event-detail')"
              @click="openDetail(optionItem, optionCriteria)"
            >
              <p class="mx-1">
                <font-awesome-icon
                  class="fa-lg text-muted mb-2"
                  icon="eye"
                /><br />
                <b>View Detail</b><br />
                <span class="text-muted"
                  >Get more insights into the event, <b>{{ optionItem }}</b
                  >.</span
                >
              </p>
            </div>
            <div
              class="py-4 choices-block"
              v-bind:class="{
                'col-md-4': option2show.length >= 3,
                'col-md-6': option2show.length < 3,
              }"
              v-if="option2show.includes('recording-event')"
              @click="openDetail(optionItem, 'recording-event')"
            >
              <p class="mx-1">
                <font-awesome-icon
                  class="fa-lg text-muted mb-2"
                  icon="video"
                /><br />
                <b>Watch Recording</b><br />
                <span class="text-muted"
                  >Watch recording of people who have triggered the event,
                  <b>{{ optionItem }}</b
                  >.</span
                >
              </p>
            </div>
            <div
              class="py-4 choices-block"
              v-bind:class="{
                'col-md-4': option2show.length >= 3,
                'col-md-6': option2show.length < 3,
              }"
              v-if="option2show.includes('recording-click')"
              @click="openDetail(optionItem, 'recording-click')"
            >
              <p class="mx-1">
                <font-awesome-icon
                  class="fa-lg text-muted mb-2"
                  icon="video"
                /><br />
                <b>Watch Recording</b><br />
                <span class="text-muted"
                  >Watch recording of people who have clicked on the text,
                  <b>{{ optionItem }}</b
                  >.</span
                >
              </p>
            </div>

            <div
              class="py-4 choices-block"
              v-bind:class="{
                'col-md-4': option2show.length >= 3,
                'col-md-6': option2show.length < 3,
              }"
              v-if="option2show.includes('add-automation')"
              @click="openDetail(optionItem, 'add-automation')"
            >
              <p class="mx-1">
                <font-awesome-icon
                  class="fa-lg text-muted mb-2"
                  icon="mouse"
                /><br />
                <b>Create automation</b><br />
                <span class="text-muted"
                  >Add automation to send out emails whenever someone has
                  triggered, <b>{{ optionItem }}</b
                  >.</span
                >
              </p>
            </div>

            <div
              class="py-4 choices-block"
              v-bind:class="{
                'col-md-4': option2show.length >= 3,
                'col-md-6': option2show.length < 3,
              }"
              v-if="option2show.includes('recording-device')"
              @click="openDetail(optionItem, 'recording-device')"
            >
              <p class="mx-1">
                <font-awesome-icon
                  class="fa-lg text-muted mb-2"
                  icon="video"
                /><br />
                <b>Watch Recording</b><br />
                <span class="text-muted"
                  >Watch recordings of people who is browing with a
                  <b>{{ optionItem }}</b
                  >.</span
                >
              </p>
            </div>

            <div
              class="py-4 choices-block"
              v-bind:class="{
                'col-md-4': option2show.length >= 3,
                'col-md-6': option2show.length < 3,
              }"
              v-if="option2show.includes('recording-os')"
              @click="openDetail(optionItem, 'recording-os')"
            >
              <p class="mx-1">
                <font-awesome-icon
                  class="fa-lg text-muted mb-2"
                  icon="video"
                /><br />
                <b>Watch Recording</b><br />
                <span class="text-muted"
                  >Watch recordings of people who is browing with an Operating
                  System, <b>{{ optionItem }}</b
                  >.</span
                >
              </p>
            </div>

            <div
              class="py-4 choices-block"
              v-bind:class="{
                'col-md-4': option2show.length >= 3,
                'col-md-6': option2show.length < 3,
              }"
              v-if="option2show.includes('recording-browser')"
              @click="openDetail(optionItem, 'recording-browser')"
            >
              <p class="mx-1">
                <font-awesome-icon
                  class="fa-lg text-muted mb-2"
                  icon="video"
                /><br />
                <b>Watch Recording</b><br />
                <span class="text-muted"
                  >Watch recordings of people who is browing with a browser,
                  <b>{{ optionItem }}</b
                  >.</span
                >
              </p>
            </div>
          </div>
        </div>
      </modal>
      <modal
        name="show-first-login"
        :adaptive="true"
        width="100%"
        height="100%"
        class="full-modal"
        :clickToClose="false"
      >
        <FirstTimeLogin />
      </modal>
      <modal
        name="show-create-website"
        :adaptive="true"
        height="auto"
        width="500px"
        @before-close="getWidget()"
      >
        <CreateWebsite @startTour="showWidgetKey"></CreateWebsite>
      </modal>

      <modal
        name="show-code"
        :adaptive="true"
        width="100%"
        height="100%"
        @before-open="modalOnOpen"
        @before-close="modalOnClose"
      >
        <div class="px-3">
          <GetCode :secretCode="secretKey"></GetCode>
        </div>
      </modal>
      
      <modal
        style="z-index: 10000"
        name="email_reminder"
        :adaptive="true"
        width="750px"
        height="auto"
        styles="border-radius: 10px;"
      >
        <EmailReminder></EmailReminder>
      </modal>
      <modal style="z-index: 10000" class="to-right full-modal" name="show-shareSettings" width="500px" height="100%" :adaptive="true">
        <shareSettings @permissionChanged="checkForFlag()"></shareSettings>
      </modal>
    </div>
  </div>
</template>

<script>
const WidgetForm = () => import('@/components/WidgetForm.vue')
const Visitor = () => import('@/components/Visitor.vue')
const IpDeviceInfo = () => import('@/components/IpDeviceInfo.vue')
const VisitorProfile = () => import('@/components/VisitorProfile.vue')
const Record = () => import('@/pages/Record.vue')
const shareSettings = () => import('@/pages/shareSetting.vue')
const Website = () => import('@/pages/Website.vue')
const GetCode = () => import('@/components/GetCode.vue')

import { store } from '@/store'

import Payment from '@/components/Payment.vue'
import CreateWebsite from '@/components/CreateWebsite.vue'
import { VueSvgGauge } from 'vue-svg-gauge'
import Popup from '@/components/Popup.vue'
import format from 'date-fns/format'
import moment from 'moment'
import MonthlyChart from '@/components/Dashboard/MonthlyChart.vue'
import CohortGraph from '@/components/Dashboard/CohortGraph.vue'
import AcquisitionChannel from '@/components/Dashboard/AcquisitionChannel.vue'
import Analytics from '@/pages/Analytics.vue'
import MapChart from 'vue-map-chart'
import FirstTimeLogin from '../components/FirstTimeLogin'
import Driver from 'driver.js'
import 'driver.js/dist/driver.min.css'
import Announcement from '@/components/Announcement.vue'
import EmailReminder from '@/components/EmailReminder.vue'

export default {
  components: {
    Visitor,
    Popup,
    WidgetForm,
    Payment,
    CreateWebsite,
    Website,
    GetCode,
    VueSvgGauge,
    MonthlyChart,
    Record,
    Analytics,
    MapChart,
    IpDeviceInfo,
    VisitorProfile,
    CohortGraph,
    AcquisitionChannel,
    Announcement,
    FirstTimeLogin,
    EmailReminder,
    shareSettings
  },
  watch: {
    '$store.getters.datepicker.dashboard': {
      handler: function (date) {
        this.realtimeStatLoaded = false
        this.cohort.key++
        this.getWidget()
        this.loadStats()
        this.loadEvents()
        this.loadNewVsReturn()
        this.loadTechnologies()
        this.loadTopPages()
      },
      deep: true
    }
  },
  store,
  data: function () {
    return {
      message: {
        key: 'price',
        title: 'Upcoming Price Change',
        body: `Effectively on July 15, the pricing plan will be increased by 50% from the current pricing.<br>
        Existing paid customers will not receive a pricing increase unless they upgrade after 15th of July.<br>
        **You can still subscribe to our plans at the old price until July 14.**<br>
        Explore our pricing plan to find the best fits for your needs before the price adjustment, or talk to us if you need help! ;)`,
        img: 'https://uploads-ssl.webflow.com/62679692b1466017b8eae590/62a491cca8f8d8599e1a546d_megaphone.png',
        cta: 'Go to Pricing Plan',
        cta_link: 'https://app.howuku.com/subscription',
        schedule: { start: '2022-06-01', end: '2022-07-14' },
        expire: '30d'
      },
      showAdditionalOptions: null,
      showHoverOption: false,
      currentOnline: 0,
      option2show: [],
      pageview: {},
      statsLoaded: false,
      topPages: null,
      topPageShow: 'visit',
      pagesLoaded: false,
      topChannels: null,
      channelLoaded: false,
      topEvents: null,
      topEventShow: 'all',
      eventLoaded: false,
      newVsReturn: {
        new: 0,
        return: 0
      },
      topTech: null,
      topTechShow: 'browser',
      technologyLoaded: false,
      cohort: {
        key: 0,
        selected: 1,
        period: 'DAY',
        interval: 7
      },

      acquisition: {
        selected: 1,
        period: 'HOUR',
        interval: 24
      },

      visitorDetailKey: 0,
      visitors: [],
      countryData: {},
      realtimeData: {},
      realtimeStatLoaded: false,
      funnelVal: 0,
      feedbackVal: 0,
      recordVal: 0,
      widget_name: this.$session.get('widget_name'),
      bigTitleNo: 1,
      showCardNo: 0,
      showWarningFlag: !window.howukuHideWarning,
      promptMsg: '',
      widgets: {},
      secretCode: '',
      secretKey: '',
      widgetKey: '',
      email: this.$session.get('email'),
      company_id: this.$session.get('company_id'),
      company_key: this.$session.get('company_key'),
      company_name: this.$session.get('company_name'),
      editId: null,
      selectedFeature: null,
      showDesc: null,
      isNew: true,
      isLoaded: false,
      widgetCount: 0,
      totalPolls: 0,
      pageview: {
        monthly: 0,
        total: 0
      },
      date: {
        start: this.$userTimeNow().startOf('month').format('YYYY-MM-DD'),
        end: this.$userTimeNow().endOf('month').format('YYYY-MM-DD')
      },
      stats: {
        feedback: 0,
        comment: 0,
        record: 0,
        total_record: 0,
        pageview: 0,
        feedback_flag: 0,
        analytic_flag: 0,
        record_flag: 0
      },
      currentShowing: 0,
      currentDemoTab: 'sentimental',
      feature: {
        long: false,
        active: false,
        keystroke: false
      },
      planName: {},
      planSize: {},
      planPrice: {},
      planHeatmapLimit: {},
      planProjectLimit: {},
      planFunnelLimit: {},
      planTeamLimit: {},
      planBaseStorage: {},
      planRecordingLimit: {},
      isTrial: false,
      setupGuide: {
        ip: false,
        teamsize: false,
        installed: false,
        completed: 0
      },
      reportKey: 0,
      visitor_id: 0,
      timeoutRealtime: null,
      optionItem: null,
      optionCriteria: null,
      isShareSession:false,
      tempWidgetId:0,
      tempjwt:'',
      isPublicShare:false,
      isAdminRole : this.$session.get('role') !== 3 && this.$session.get('role') !== 2,
      liveRecordingData: [],
      excludedPlan:[0, 4, 101, 102, 103, 105, 201, 202, 203]
    }
  },
  filters: {},
  methods: {
    openOptionModal(item, criteria, option2show) {
      this.optionItem = item
      this.optionCriteria = criteria
      this.option2show = option2show.filter((n) => n)
      this.$modal.show('choose-option')
    },
    openDetail(item, criteria) {
      if (criteria === 'recording') { this.$router.push({ path: '/recordings?visited_url%5BLIKE%5D=' + item }) }

      if (criteria === 'referrer') {
        this.$router.push({
          path: '/recordings?referrer_url%5BLIKE%5D=' + item
        })
      }

      if (criteria === 'heatmap') { this.$router.push({ path: '/heatmap/continuous?&url=https://' + item }) }

      if (criteria === 'click') { this.$router.push({ path: '/events/click/' + item }) }

      if (criteria === 'event') { this.$router.push({ path: '/events/trigger/' + item }) }

      if (criteria === 'recording-click') { this.$router.push({ path: '/recordings?click_text=' + item }) }

      if (criteria === 'recording-event') { this.$router.push({ path: '/recordings?events=' + item }) }

      if (criteria === 'add-automation') { this.$router.push({ path: '/automation/new?event=' + item }) }

      if (criteria === 'recording-device') { this.$router.push({ path: '/recordings?device=' + item }) }

      if (criteria === 'recording-os') { this.$router.push({ path: '/recordings?operating_system=' + item }) }

      if (criteria === 'recording-browser') { this.$router.push({ path: '/recordings?browser=' + item }) }
      
      if (criteria === 'filter-url') { this.$router.push({ path: '/analytics?url=' + item.replace(/\//g, '---') }) }
      if (criteria === 'filter-referrer') { this.$router.push({ path: '/analytics?referrer=' + item.replace(/\//g, '---') }) }
    },
    shortNumber(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + 'K'
        : Math.sign(num) * Math.abs(num)
    },    
    changeCohortPeriod() {
      switch (Number(this.cohort.selected)) {
        case 1:
          this.cohort.period = 'DAY'
          this.cohort.interval = 7
          break
        case 2:
          this.cohort.period = 'WEEK'
          this.cohort.interval = 3
          break
        case 3:
          this.cohort.period = 'WEEK'
          this.cohort.interval = 6
          break
        case 4:
          this.cohort.period = 'MONTH'
          this.cohort.interval = 3
          break
        default:
          this.cohort.period = 'DAY'
          this.cohort.interval = 7
      }
      this.cohort.key++
    },
    changeAcquisitionPeriod() {
      switch (Number(this.acquisition.selected)) {
        case 1:
          this.acquisition.period = 'HOUR'
          this.acquisition.interval = 24
          break
        case 2:
          this.acquisition.period = 'DAY'
          this.acquisition.interval = 7
          break
        case 3:
          this.acquisition.period = 'WEEK'
          this.acquisition.interval = 2
          break
        case 4:
          this.acquisition.period = 'MONTH'
          this.acquisition.interval = 1
          break
        default:
          this.acquisition.period = 'HOUR'
          this.acquisition.interval = 24
      }
      this.cohort.key++
    },
    timeSince: function (time, lang) {
      return moment(time).fromNow()
    },
    showVisitor(n) {
      this.visitor_id = n
      this.$modal.show('show-profile')
    },
    processReferrer(ref) {
      let originalRef = ref
      try {
        ref = ref.toLowerCase()
      } catch (err) {}
      if (/twclid/.test(ref)) return 'Twitter Ads'
      if (/googleads.g.doubleclick.net/.test(ref)) {
        return 'Google'
      }
      if (/google/.test(ref)) {
        return 'Google'
      }
      if (/facebook/.test(ref) || /fbclid/.test(ref)) {
        return 'Facebook'
      }
      if (/quora/.test(ref)) {
        return 'Quora'
      }
      if (/indiehacker/.test(ref)) {
        return 'Indiehacker'
      }
      if (/yahoo/.test(ref)) {
        return 'Yahoo'
      }
      if (/t.co\//.test(ref)) {
        return 'Twitter'
      }
      if (/linkedin/.test(ref)) {
        return 'Linkedin'
      }
      if (/betalist/.test(ref)) {
        return 'Betalist'
      }
      if (/betapage/.test(ref)) {
        return 'Betapage'
      }
      if (/producthunt/.test(ref)) {
        return 'ProductHunt'
      }
      if (/linkedin/.test(ref)) {
        return 'Linkedin'
      }
      if (ref === '') {
        return 'Direct'
      }
      return typeof originalRef === 'string'
        ? originalRef
          .replace(/www\./, '')
          .replace(/http(s)?\:\/\//, '')
          .split('/')[0]
        : originalRef
    },
    getThemeColor(opacity) {
      return opacity === 0
        ? '#dadce0'
        : 'rgba(' + localStorage.getItem('--main-color') + ',' + opacity + ')'
    },
    processPageviews(data) {
      for (let i in data) {
        this.pageview.monthly = data[i].value
      }
      this.widget_name = this.$session.get('widget_name')
      this.reportKey++
    },
    shorten_last(string, len) {
      if (!string) return string

      if (string.length > len) return string.substring(-10, len)
      else return string
    },
    modalOnOpen() {
      document.body.style.overflow = 'hidden'
    },
    modalOnClose(event) {
      document.body.style.overflow = 'auto'
    },
    cap100(n) {
      return n < 100 ? n : 100
    },
    hideWarning() {
      this.showWarningFlag = false
      window.howukuHideWarning = true
    },
    showWarning() {
      return !window.howukuHideWarning
    },
    threshold(n) {
      return Number(n) > 1
    },
    getColor() {
      let usage = 1 - this.stats.total_record / this.recordCapacity()
      let color = 'rgb(117, 199, 145)'
      if (usage < 0.2) color = '#FB5555'
      return color
    },
    dnt(ip) {
      this.$http
        .post(process.env.API_ENDPOINT + '/blockip/add', {
          ip: ip,
          widget_id: 0
        })
        .then((response) => {
          this.$swal.fire({
            title: 'OK!',
            text: 'We have added your IP into do not track list!',
            type: 'success',
            confirmButtonColor: '#2167f5'
          })
        })
    },
    liverecording() {
      this.$http.get(process.env.API_ENDPOINT + '/currentLiveRecording')
        .then((result) => {
          this.liveRecordingData = result.data
        })      
    },
    updateWidget(id, key, value) {
      let options = {
        widget_id: id
      }

      if (key === 'feedback') {
        options.feedback_flag = value
        this.stats.feedback_flag = value
      }
      if (key === 'record') {
        options.record_flag = value
        this.stats.record_flag = value
      }
      if (key === 'heatmap') {
        options.heatmap_flag = value
        this.stats.heatmap_flag = value
      }
      if (key === 'spa') {
        options.spa_flag = value
        this.stats.spa_flag = value
      }
      if (key === 'error') options.error_flag = value

      this.$http
        .post(process.env.API_ENDPOINT + '/saveWidget', options,{
              headers: {
              'jwt': this.tempjwt
              }
            })
        .then((response) => {})
    },
    updateDescription(id, name, value) {
      this.showDesc = null
      this.$http
        .post(process.env.API_ENDPOINT + '/saveWidget', {
          widget_id: id,
          widget_name: name,
          widget_description: value
        },{
              headers: {
              'jwt': this.tempjwt
              }
            })
        .then((response) => {
          for (let i = 0; i < this.widgets.length; i++) {
            if (this.widgets[i].widget_id === id) {
              this.widgets[i].widget_description = value
            }
          }
          this.$store.commit('setWidgets', this.widgets)
        })
    },
    deleteDescription(id, name) {
      this.$swal
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'rgb(255, 75, 57)',
          cancelButtonColor: '#dcdcdc',
          confirmButtonText: 'Yes, delete it!'
        })
        .then((result) => {
          if (result.value) {
            this.$http
              .post(process.env.API_ENDPOINT + '/saveWidget', {
                widget_id: id,
                widget_name: name,
                status: 0
              },{
              headers: {
              'jwt': this.tempjwt
              }
            })
              .then((response) => {
                for (let i = 0; i < this.widgets.length; i++) {
                  if (this.widgets[i].widget_id === id) {
                    this.widgets[i].status = 0
                  }
                }
                this.$store.commit('setWidgets', this.widgets)
              })
            this.$swal.fire({
              title: 'Deleted!',
              text: 'Your widget ' + name + ' has been deleted.',
              type: 'success',
              confirmButtonColor: '#2167f5'
            })
          }
        })
    },
    currentMonth() {
      return this.$userTimeNow().format('MMMM')
    },
    storagePlan() {
      let plan = this.$session.get('paid_plan')
      return this.planBaseStorage[plan]
    },
    trackedCount() {
      let plan = this.$session.get('paid_plan')
      return this.planSize[plan]
    },
    recordCapacity() {
      let plan = this.$session.get('paid_plan')
      return this.planRecordingLimit[plan]
    },
    currentPlan() {
      let plan = this.$session.get('paid_plan')
      return this.planName[plan]
    },
    shorten(string, n) {
      if (string.length > n) return string.substring(0, n) + '...'
      else return string
    },
    formatit(date) {
      let m = moment(date)
      let iscurrentDate = m.isSame(new Date(), 'day')
      if (iscurrentDate) return m.fromNow()
      return m.format('DD MMM')
    },
    format(p1, p2) {
      return !isNaN(new Date(p1).getTime()) ? format(p1, p2) : ''
    },
    newUserCheck() {
      if (this.$session.get('new_user')) {
        this.$router.push({ path: '/welcome' })
      }
    },
    loadRealtimeData() {
      this.$http
        .get(
          process.env.API_ENDPOINT +
            '/dashboard/visitors/' +
            (!this.isShareSession)? this.$session.get('widget_id') : this.tempWidgetId,{
              headers: {
              'jwt': this.tempjwt
              }
            }
        )
        .then((result) => {
          this.visitors = result.data
          this.visitorDetailKey++

          this.$http
            .get(
              process.env.API_ENDPOINT +
                '/dashboard/real-time/' +
                (!this.isShareSession)? this.$session.get('widget_id') : this.tempWidgetId,{
              headers: {
              'jwt': this.tempjwt
              }
            }
            )
            .then((result) => {
              this.realtimeStatLoaded = true
              this.realtimeData = result.data

              clearTimeout(this.timeoutRealtime)
              this.timeoutRealtime = setTimeout(() => {
                try {
                  if (this.$route.name == 'Dashboard') this.loadRealtimeData()
                } catch (err) {}
              }, 30000)
            })
        })
    },
    getWidget() {
      this.isLoaded = false
      this.pageview.total = 0

      this.$http
        .post(process.env.API_ENDPOINT + '/getWidgets', {
          widget_id: ((!this.isShareSession)? this.$session.get('widget_id') : this.tempWidgetId)
        },{
            headers: {
            'jwt': this.tempjwt
            }
          })
        .then((response) => {
          // this.loadRealtimeData()
          if (response.data && response.data.length) {
            this.feedback_flag = response.data[0].feedback_flag
            this.record_flag = response.data[0].record_flag
            this.heatmap_flag = response.data[0].heatmap_flag
            this.spa_flag = response.data[0].spa_flag
            this.error_flag = response.data[0].error_flag
            this.secretKey = response.data[0].widget_key
            if(!this.isShareSession){
              this.$session.set('secretkey', response.data[0].widget_key)
            }
            this.pageview.total = response.data[0].pageview_total || 0
            this.setupGuide.installed = this.pageview.total
          }

          if (this.$isHowuku || this.$isMida) {
            try {
              import("company-email-validator").then((workemail) => {
                _cio.identify({
                  id: this.$session.get('email'), // Use either id or email.
                  name: this.$session.get('name'),
                  company_email: workemail.isCompanyEmail(
                    this.$session.get('email')
                  ),
                  installed: Number(this.pageview.total) >= 1 ? 1 : 0,
                  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
                })
              }).catch(error => console.log(error));     
            } catch (err) {}
          }

          this.secretCode = this.secretKey

          let feature = (data, value) => {
            return data.includes(value)
          }
          this.widgets = response.data[0].feature_acl
          this.funnelVal = feature(this.widgets, 'funnel')
          this.feedbackVal = feature(this.widgets, 'feedback')
          this.recordVal = feature(this.widgets, 'recording')

          this.$http.get(process.env.API_ENDPOINT + '/team',{
              headers: {
              'jwt': this.tempjwt
              }
            }).then((response) => {
            this.setupGuide.teamsize = response.data.length > 1
            this.isLoaded = true
          })

          this.$http
            .post(process.env.API_ENDPOINT + '/blockip', {},{
              headers: {
              'jwt': this.tempjwt
              }
            })
            .then((response) => {
              this.setupGuide.ip = false
              for (let i in response.data) {
                if (response.data[i].is_current) {
                  this.setupGuide.ip = true
                  break
                }
              }
            })
            if(!this.isShareSession){
                this.$http.get(
                    process.env.API_ENDPOINT +
                      '/dashboard/country-data/' +
                      this.$session.get('widget_id') 
                  )
                  .then((result) => {
                    this.countryData = result.data
                    console.log(this.countryData)
                  })
              }else{
                this.$http.get(
                    process.env.API_ENDPOINT + '/dashboard/country-data/' + this.tempWidgetId ,{
                        headers: {
                        'jwt': this.tempjwt
                      }
                    }
                  )
                  .then((result) => {
                    this.countryData = result.data
                    console.log(this.countryData)
                  })
              }
            })
    },
    getCompletedCount() {
      let count = 0
      for (let i in this.setupGuide) {
        if (this.setupGuide[i]) {
          count++
        }
      }
      return count
    },
    checkNewUser() {

      this.$http.get(process.env.API_ENDPOINT + '/checkNewUser')
        .then((response) => {
          let data = response.data
          // data 0 = new user, role 0 = owner
          if (data === 0 && this.$session.get('role') === 0 && this.$isHowuku) {
            this.$session.set('first_login', 'yes')
            if (!this.$isOptimize)
              this.$modal.show('show-first-login')
          }
        })
        .catch((err) => {
          console.log(err, 'check new user')
        })
    },
    checkEmailReminder() {
      this.$http.post(process.env.API_ENDPOINT + '/getUsers').then((response) => {
        const data = response.data;

        if (!data[0].status && this.$session.get('first_login') && this.$session.get('first_login') != 'yes') {
          this.$modal.show('email_reminder');
        }
      })
    },
    initiate() {
      this.realtimeStatLoaded = false
      // if(!this.isShareSession && !this.excludedPlan.includes(this.$session.get('paid_plan')) && this.$isHowuku){
      //   this.checkNewUser()
      // }
      this.getWidget()
      this.loadEvents()
      this.loadNewVsReturn()
      this.loadTechnologies()
      this.loadStats()
      this.loadTopPages()
      // if (!this.excludedPlan.includes(this.$session.get('paid_plan')) && this.$isHowuku) {
      //   this.checkEmailReminder()
      // }
      let waitForWidgetId = setInterval(() => {
        if (this.$session.get('widget_id')) {
          clearInterval(waitForWidgetId)
          this.$http.defaults.headers.widget_id = (!this.isShareSession)? this.$session.get('widget_id') : this.tempWidgetId
          // this.loadRealtimeData()
          if(!this.isShareSession){
            try {
              if (!window.location.href.includes('localhost:') && (this.$isHowuku || this.$isMida)) {
                import("company-email-validator").then((workemail) => {
                  _cio.identify({
                    id: this.$session.get('email'), // Use either id or email.
                    name: this.$session.get('name'),
                    company_email: workemail.isCompanyEmail(
                      this.$session.get('email')
                    ),
                    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
                  })
                  
                }).catch(error => console.log(error));     
  
                window.howuku.identify({
                  id: this.$session.get('user_id'),
                  name: this.$session.get('name'),
                  email: this.$session.get('email'),
                  company_id: this.$session.get('company_id'),
                  odd_number: Number(this.$session.get('company_id')) % 2,
                  plan: this.$session.get('paid_plan'),
                  lifetime: this.$session.get('lifetimedeal') ? 'Y' : 'N'
                })
              }
            } catch (e) {}
          }
        }
      }, 100)
    },
    removeProtocol: function (text) {
      text = text.replace(/^https:\/\//g, '')
      text = text.replace(/^http:\/\//g, '')
      text = text.replace(/^www\./g, '')
      return text
    },
    removeDomain: function (text) {
      return (text.indexOf("/") !== -1 ? '/' + text.substring(text.indexOf("/") + 1) : 'homepage')
    },
    showEdit(id, feature) {
      this.editId = id
      this.selectedFeature = feature
      this.$modal.show('widget-modal')
    },
    showWordpress(key) {
      this.widgetKey = key
      this.$modal.show('show-wordpress')
    },
    thousandFormat(x) {
      if (typeof x === 'number') x = x.toString()
      if (typeof x !== 'string') return x
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    shortNumber(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + 'K'
        : Math.sign(num) * Math.abs(num)
    },
    showCode(key, isNew) {
      /* eslint-disable */
      this.$modal.show('show-code')
    },
    showWidgetKey(key) {
      setTimeout(() => {
        const driver = new Driver({
          allowClose: false,
          overlayClickNext: true,
        })

        driver.defineSteps([
          {
            element: '#track-' + key,
            popover: {
              title: 'Get the code',
              description:
                'You need to copy and paste the tracking code to your website to use Howuku.',
              position: 'top',
            },
          },
          {
            element: '#feedback-' + key,
            popover: {
              title: 'Customize your feedback',
              description:
                'You can customize your feedback text and appearances here, change the widget color to match your website theme.',
              position: 'top',
            },
          },
          {
            element: '#record-' + key,
            popover: {
              title: 'Enable recording feature',
              description:
                'Be sure to enable visitor recording and heatmap feature in here.',
              position: 'top',
            },
          },
          {
            element: '#feature-list',
            popover: {
              title: 'Feature list',
              description: 'All enabled feature will be showing here.',
              position: 'bottom',
            },
          },
          {
            element: '.howu-tab',
            popover: {
              title: 'Finally..',
              description:
                "Don't forget to let us know what do you think about our service! :)",
              position: 'left',
            },
          },
        ])
        driver.start()
        // have to wait for component to render.
      }, 1000)
    },
    setRecordFeature(feature) {
      if (feature === 'active') {
        this.feature.active = !this.feature.active
      }
      if (feature === 'long') {
        this.feature.long = !this.feature.long
      }
      if (feature === 'keystroke') {
        this.feature.keystroke = !this.feature.keystroke
      }
    },
    thousandFormat(x = 0) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    loadEvents() {
      this.eventLoaded = false
      let query =
        'startDate=' + this.$store.getters.datepicker.dashboard.startDate

      if (this.$store.getters.datepicker.dashboard.endDate)
        query += '&endDate=' + this.$store.getters.datepicker.dashboard.endDate

      let type = this.topEventShow

      if (type === 'click') query += '&type=1'
      if (type === 'event') query += '&type=2'

      this.$http
        .get(process.env.API_ENDPOINT + '/dashboard/top-events?' + query,{
              headers: {
              'jwt': this.tempjwt,
              'widgetid' : (!this.isShareSession)? this.$session.get('widget_id') : this.tempWidgetId
              }
            })
        .then((response) => {
          this.topEvents = response.data
          this.eventLoaded = true
        })
    },
    loadNewVsReturn() {
      let query =
        'startDate=' + this.$store.getters.datepicker.dashboard.startDate

      if (this.$store.getters.datepicker.dashboard.endDate)
        query += '&endDate=' + this.$store.getters.datepicker.dashboard.endDate

      this.$http
        .get(process.env.API_ENDPOINT + '/dashboard/new-vs-return?' + query,{
              headers: {
              'jwt': this.tempjwt,
              'widgetid' : (!this.isShareSession)? this.$session.get('widget_id') : this.tempWidgetId
              }
            })
        .then((response) => {
          this.newVsReturn = response.data
        })
    },
    loadTechnologies() {
      this.technologyLoaded = false
      let query =
        'startDate=' + this.$store.getters.datepicker.dashboard.startDate

      if (this.$store.getters.datepicker.dashboard.endDate)
        query += '&endDate=' + this.$store.getters.datepicker.dashboard.endDate

      let type = this.topTechShow

      query += '&type=' + type

      this.$http
        .get(process.env.API_ENDPOINT + '/dashboard/top-technology?' + query,{
              headers: {
              'jwt': this.tempjwt,
              'widgetid' : (!this.isShareSession)? this.$session.get('widget_id') : this.tempWidgetId
              }
            })
        .then((response) => {
          this.topTech = response.data
          this.technologyLoaded = true
        })
    },
    precisionRound: function (number, precision) {
      var factor = Math.pow(10, precision)
      return Math.round(number * factor) / factor
    },
    secondsToTime: function (secs) {
      return secs <= 0 || !secs
        ? '0s'
        : secs > 60
        ? ~~((secs % 3600) / 60) + 'm ' + (~~secs % 60) + 's'
        : ~~secs + 's'
    },
    loadTopPages() {
      let param =
        'startDate=' + this.$store.getters.datepicker.dashboard.startDate

      if (this.$store.getters.datepicker.dashboard.endDate)
        param += '&endDate=' + this.$store.getters.datepicker.dashboard.endDate

      this.pagesLoaded = false
      this.channelLoaded = false
      this.$http
        .get(process.env.API_ENDPOINT + '/dashboard/top-pages-2?' + param,{
              headers: {
              'jwt': this.tempjwt,
              'widgetid' : (!this.isShareSession)? this.$session.get('widget_id') : this.tempWidgetId
              }
            })
        .then((response) => {
          this.topPages = response.data
          console.log('top pages : ' + this.topPages)
          this.pagesLoaded = true
        })

      this.$http
        .get(process.env.API_ENDPOINT + '/dashboard/top-channels?' + param,{
              headers: {
              'jwt': this.tempjwt,
              'widgetid' : (!this.isShareSession)? this.$session.get('widget_id') : this.tempWidgetId
              }
            })
        .then((response) => {
          this.topChannels = response.data
          this.channelLoaded = true
        })
    },
    shorten(string, len) {
      if (!string) return string

      if (string.length > len) return string.substring(0, len) + '...'
      else return string
    },
    loadStats() {
      this.statsLoaded = false

      this.$http
        .post(process.env.API_ENDPOINT + '/dashboard/stat', {
          widget_id: (!this.isShareSession)? this.$session.get('widget_id') : this.tempWidgetId,
          startDate: this.$store.getters.datepicker.dashboard.startDate,
          endDate: this.$store.getters.datepicker.dashboard.endDate,
        },{
              headers: {
              'jwt': this.tempjwt
              }
            })
        .then((response) => {
          let data = response.data

          this.pageview['count'] = data.pageview
          this.pageview['unique'] = data.session
          this.bounce = this.precisionRound(data.bounced / data.session * 100, 2)
          this.sessionTime = this.secondsToTime(
            data.duration
          )

          setTimeout(() => {
            this.statsLoaded = true
          }, 100);
        })
      
      // this.statsLoaded = false
      // this.$http
      //   .post(process.env.API_ENDPOINT + '/tracking/raw', {
      //     widget_id: (!this.isShareSession)? this.$session.get('widget_id') : this.tempWidgetId,
      //     startDate: this.$store.getters.datepicker.dashboard.startDate,
      //     endDate: this.$store.getters.datepicker.dashboard.endDate,
      //   },{
      //         headers: {
      //         'jwt': this.tempjwt
      //         }
      //       })
      //   .then((response) => {
      //     let data = response.data
      //     this.totalPageViewManual = 0

      //     this.showChart = true
      //     this.pageview['count'] = 0
      //     this.pageview['unique'] = 0

      //     this.pageview['count_history'] = []
      //     this.pageview['unique_history'] = []

      //     this.chartData = data.pageview
      //     if(!this.$route.params.encryptedParam){
      //       this.tz = localStorage.getItem('Tz')
      //     }
      //     // page view
      //     for (let i = 0; i < data.pageview.length; i++) {
      //       this.pageview['count_history'].push(data.pageview[i].count)
      //       this.pageview['count'] += data.pageview[i].count
      //       this.noData = false
      //     }

      //     this.visitorIds = []

      //     // unique
      //     for (let i = 0; i < data.unique.length; i++) {
      //       this.pageview['unique_history'].push(data.unique[i].count)
      //       this.pageview['unique'] += data.unique[i].count
      //       this.visitorIds.push(data.unique[i].visitor_id)
      //     }

      //     // bounce
      //     this.bounce = this.precisionRound(data.bounce[0].bounce_rate * 100, 2)

      //     // average pageviews per visit
      //     let pvpv = this.pageview['count'] / this.pageview['unique']

      //     // session time
      //     this.pageview.rawSessionTime =
      //       data.sessionTime[0].avg_sess_time * pvpv
      //     this.sessionTime = this.secondsToTime(
      //       data.sessionTime[0].avg_sess_time * pvpv
      //     )
      //   })
    },
    openShareLinkSettings(){
      this.$modal.show('show-shareSettings')
    },
    assignValuesForShare(){
      if(!this.$route.params.encryptedParam){
        this.tempjwt = localStorage.getItem('jwt')
        this.tempWidgetId = this.$session.get('widget_id')
        this.checkForFlag()
      }else{
        this.isShareSession = true
        //if is not share session then assign 
        this.tempjwt = window.TEMP_JWT
        this.tempWidgetId = window.TEMP_WIDGET_ID
        this.$store.commit('setDatepicker', {
          module: 'dashboard',
          name: 'startDate',
          data: window.TEMP_START_DATE
        })
        this.$store.commit('setDatepicker', {
          module: 'dashboard',
          name: 'endDate',
          data: window.TEMP_END_DATE
        })
      }
    },
    expandVisitor(){
      if(this.isShareSession){
        let domain = 'https://app.howuku.com/'
        if(window.location.host.includes('localhost')){
          domain = 'http://localhost:8080/'
        }
        let url = domain + 'share/visitor/retention/' + this.$route.params.encryptedParam
         window.location.href= url
      }
    },
    expandMap(){
      if(this.isShareSession){
        let domain = 'https://app.howuku.com/'
        if(window.location.host.includes('localhost')){
          domain = 'http://localhost:8080/'
        }
        let url = domain + 'share/visitor/map/' + this.$route.params.encryptedParam
         window.location.href= url
      }
    },
    expandAccquisition(){
      if(this.isShareSession){
        let domain = 'https://app.howuku.com/'
        if(window.location.host.includes('localhost')){
          domain = 'http://localhost:8080/'
        }
        let url = domain + 'share/visitor/acquisition/' + this.$route.params.encryptedParam
        window.location.href= url
      }
    },
    checkForFlag(){
        this.$http.get(process.env.API_ENDPOINT + '/sharePermission').then(result =>{
            console.log((result.data))
            for (let index = 0; index < result.data.length; index++) {
                const element = result.data[index];
                if(element.modules === this.$route.name){
                    this.isPublicShare = (element.flag===0) ? true:false
                }
            }
        })
    },
  },
  async mounted() {

    let previousAnnouncement = []
    // setInterval(() => {
    //   this.liverecording()
    // }, 5000)
    if(!this.$route.params.encryptedParam){
      let key = 'announcement_' + this.message.key
      previousAnnouncement = await this.$findAuditlog({
        action: key,
      })
    }

    if (
      !previousAnnouncement.length && // was not previously shown in audit log
      this.$session.get('role') === 0 && // is owner
      window.location.href.includes('.howuku.com') && // not whitelabel
      new Date() >= new Date(this.message.schedule.start) &&
      new Date() <= new Date(this.message.schedule.end)
    ) {
      this.$modal.show('announcement')
      this.$auditlog({
        module: 'announcement',
        action: key,
      })
    } 
    
    // if no heatmap preference, set v2
    if (!localStorage.getItem('heatmap_preference')) {
      localStorage.setItem('heatmap_preference', 'v2')
    }

    this.$http.post(process.env.API_ENDPOINT + '/updateLastActivity',{
              headers: {
              'jwt': this.tempjwt
              }
            }).then((response) => {
      console.log('Activity updated');  
    });

    // function subsequences(arr) {
    //   var res = [[]]
    //   for (var i = 0; i < arr.length; i++)
    //     for (var j = i + 1; j <= arr.length; j++) {
    //       if (arr[i] === arr[0]) res.push(arr.slice(i, j))
    //       else break
    //     }

    //   return res
    // }
    // function removeItem(array, item) {
    //   for (var i = 0; i < array.length; i++) {
    //     if (array[i] == item && i !== 0) {
    //       array.splice(i, 1)
    //     }
    //   }
    // }

    // let possibilities = {}
    // this.$http.get(process.env.API_ENDPOINT + '/event-flow').then((response) => {
    //   let data = response.data
    //   for (let i in data) {
    //     let firstLevel = data[i].events.split(',')
    //     firstLevel = firstLevel.splice(firstLevel.indexOf('Schedule A Demo'))
    //     removeItem(firstLevel, 'Schedule A Demo')

    //     if (firstLevel.length > 1) {
    //       let c = subsequences(firstLevel)

    //       for (let j in c) {
    //         let newkey = c[j].join('>')
    //         if (newkey === '') continue

    //         if (!possibilities[newkey]) possibilities[newkey] = 0
    //         possibilities[newkey]++
    //       }
    //     }
    //   }assignValuesForShare

    //   let keys = Object.assign(
    //     ...Object.entries(possibilities)
    //       .sort(({ 1: a }, { 1: b }) => b - a)
    //       .slice(0, 10)
    //       .map(([k, v]) => ({ [k]: v }))
    //   )
    // })

    // setInterval(() => {
    //   axios
    //     .get(process.env.API_ENDPOINT + '/dashboard/online')
    //     .then((result) => {
    //       this.currentOnline = result.data.length
    //     })
    // }, 10000)
  },
  beforeMount() {
    this.assignValuesForShare()
      this.initiate()
      this.$notiCount()
        this.$http.get(process.env.API_ENDPOINT + '/plan',{
                  headers: {
                  'jwt': this.tempjwt
                  }
                }).then((response) => {
          let data = response.data
          for (let i = 0; i < data.length; i++) {
            this.planName[i] = data[i].plan_name
            this.planPrice[i] = data[i].price
            this.planSize[i] = data[i].pageview
            this.planHeatmapLimit[i] = data[i].heatmap_limit
            this.planProjectLimit[i] = data[i].project_limit
            this.planFunnelLimit[i] = data[i].funnel_limit
            this.planTeamLimit[i] = data[i].team_limit
            this.planBaseStorage[i] = data[i].base_storage
            this.planRecordingLimit[i] = data[i].recording_limit
          }
          let plan = this.$session.get('paid_plan')
          if(!this.isShareSession){
            this.planSize[plan] > 0 ? this.$session.set('is_pageview', 1) : this.$session.set('is_pageview', 0)
          }
        })
    //set the paid_plan_expiry_retry to session 
    if(!this.$route.params.encryptedParam){
      this.$http.get(process.env.API_ENDPOINT + '/checkFor30DayExpire',{
        headers: {
        'jwt': this.tempjwt
        }
      }).then((response) => {
        let data = response.data
        console.log(data.prohibit)
        if(data.prohibit === 1){
          this.$session.set('paid_plan_expiry_retry',data.result[0].paid_plan_expiry_retry)
        }else{
          this.$session.set('paid_plan_expiry_retry',null)
        }
      })
    }
  },
}
</script>
<style>
thead {
  text-align: left;
}

.link {
  font-weight: bold;
  color: #007bff;
  cursor: pointer;
}

.code-section {
  background-color: #f3f3f3;
  border: 1px solid #cacaca;
  padding: 20px;
}

.code-section code {
  word-break: break-all;
}

.delete-button:hover {
  transform: scale(1.1);
}

.text-wrap {
  display: inline-block;
  text-overflow: ellipsis;
  height: 30px;
}

.pointer {
  cursor: pointer;
}

.card-noframe {
  border: none !important;
  box-shadow: none !important;
}

.ipinfo-tbody td {
  white-space: nowrap;
  overflow: hidden;
}

.header-tab {
  border-top: 3px solid rgba(0, 0, 0, 0);
}

.header-tab.active {
  background-color: #4b60c4 !important;
  color: #ffffff !important;
}

.header-tab:hover {
  background-color: #f5f5f5;
}

.delete-button {
  visibility: none;
  cursor: pointer;
}

.card-hover:hover .delete-button {
  visibility: visible;
}

.text-inactive {
  color: #00000040;
}

.table-border-bottom tr {
  border-top-color: 0;
  border-bottom-color: gray 1px solid;
}

.info-panel {
  background-color: #4b60c4;
  color: #ffffff;
  padding: 20px;
  border-radius: 3px;
}

.info-panel2 {
  background-color: #dadfe6;
  padding: 20px;
  border-radius: 3px;
}

.feature {
  /* background-color: #e0effa; */
  border-radius: 4px;
  padding: 20px;
  color: #000000;
  background-color: #f6f9ff;
  -webkit-box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11),
    0 1px 3px rgba(0, 0, 0, 0.08);
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.feature p {
  min-height: 100px;
}

body {
  background: #fff;
}

.metric {
  padding: 10%;
}

.metric svg {
  max-width: 100%;
}

.metric path {
  stroke-width: 75;
  stroke: #ecf0f1;
  fill: none;
}

.metric text {
  font-family: 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.metric.participation path.data-arc {
  stroke: #3498db;
}

.metric.participation text {
  fill: #3498db;
}

.metric.completion path.data-arc {
  stroke: #27ae60;
}

.metric.completion text {
  fill: #27ae60;
}

.metric.blocked path.data-arc {
  stroke: #e74c3c;
}

.metric.blocked text {
  fill: #e74c3c;
}

.gauge-container svg,
.gauge {
  height: auto !important;
}

.gauge-container svg {
  width: 75%;
}

.up {
  color: green;
  font-size: 18px;
}
.up:before {
  content: '+';
  font-size: 14px;
}

.down {
  color: red;
  font-size: 18px;
}

.down:before {
  content: '-';
  font-size: 14px;
}

.card-accordion {
  border: 0;
}

.card-accordion > .card-header {
  padding: 16px;
  cursor: pointer;
  background-color: var(--background);
  color: var(--color);
  border: 1px solid rgb(237, 240, 242);
  border-radius: 1px;
}

.card-accordion .card-body {
  background: rgba(var(--background-muted), 0.5);
}

#accordion,
#accordion2 {
  /* border: 1px #00000050 solid; */
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.05), 0 1px 3px rgba(0, 0, 0, 0.02);
  margin-top: 10px;
  margin-bottom: 20px;
}

.sub-header {
  font-size: 16px;
}

.card-body-custom {
  padding-top: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
  padding-bottom: 0px !important;
  /* border-top: 2px solid #9ebcff; */
}

.bg-highlight {
  /* background-color: #ff634715; */
  background-color: rgba(var(--main-color),.05) !important;
  /* background-color: rgba(var(--main-color), 0.08); */
  white-space: nowrap;
  border-radius: 4px;
}

.choices-block {
  border-radius: 14px;
  cursor: pointer;
  word-wrap: break-word;
}

.choices-block:hover {
  background-color: #cccccc30;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue